export default __webpack_public_path__ + "static/media/secret_4.4a4af400.jpg";